/** Tipos e rótulos do Radar de Receita e da temperatura (sem dependência de rede: seguros para testes e componentes). */

export type Temperature = 'quente' | 'morna' | 'fria';

export const TEMPERATURE_LABELS: Record<Temperature, string> = {
  quente: 'Quente',
  morna: 'Morna',
  fria: 'Fria',
};

export function normalizeTemperature(raw: unknown): Temperature | null {
  return raw === 'quente' || raw === 'morna' || raw === 'fria' ? raw : null;
}

export interface RevenueItem {
  cardId: number;
  sectorId: number;
  contactId: number;
  contactName: string;
  title: string | null;
  columnId: number;
  columnName: string;
  value: number | null;
  currency: string | null;
  temperature: Temperature | null;
  temperatureEvidence: string | null;
  daysStalled: number;
  wonAt: string | null;
  path: string;
}

export interface RevenueSettings {
  weightHot: number;
  weightWarm: number;
  weightCold: number;
  stalledDays: number;
}

export const DEFAULT_REVENUE_SETTINGS: RevenueSettings = { weightHot: 0.6, weightWarm: 0.3, weightCold: 0.1, stalledDays: 7 };

/** Radar de Receita (lido dos cards): valor em negociação, ponderado, paradas, sem valor e fechado no mês. */
export interface RevenueRadar {
  sectorIds: number[];
  pipelineValue: number;
  openCount: number;
  valuedCount: number;
  weighted: number;
  unweightedValue: number;
  unweightedCount: number;
  temperatures: { temperature: Temperature; label: string; weight: number; count: number; value: number; weighted: number }[];
  settings: Record<string, RevenueSettings>;
  stalledDays: number;
  stalledCount: number;
  stalledValue: number;
  stalled: RevenueItem[];
  withoutValueCount: number;
  withoutValue: RevenueItem[];
  otherCurrencies: { currency: string; count: number; total: number }[];
  columns: { columnId: number; count: number; valuedCount: number; valueBrl: number; otherCurrencyCount: number }[];
  closedMonth: {
    label: string;
    count: number;
    value: number;
    valuedCount: number;
    previousCount: number;
    previousValue: number;
    previousLabel: string;
    previousFullCount: number;
    previousFullValue: number;
    deltaPct: number | null;
    wonWithoutDate: number;
    cases: RevenueItem[];
  };
  hasWonColumn: boolean;
  howCalculated: string[];
  generatedAt: string;
}
